import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {PersistenceFetchApiInterface} from "./persistence-fetch";

/**
 * API interface for loading a single frozen snapshot of a valuation from the persistence
 * (GET {@link RevaApi.PATH_VALUATIONS}/{id}/snapshots/{snapshotNumber}).
 *
 * The response is a regular {@link import("@reva/shared/valuation-data").ValuationData}
 * (with `isSnapshot === true` and populated `snapshotMetadata`), so GET execution and error handling
 * (incl. the R220 "no snapshot found" mapping) are inherited from {@link PersistenceFetchApiInterface}.
 */
export class PersistenceFetchSnapshotApiInterface extends PersistenceFetchApiInterface {
    private readonly snapshotNumber: number;

    constructor(id: string, snapshotNumber: number) {
        super(id); // forceUpdateExternalData = null (meaningless for a frozen snapshot)
        this.snapshotNumber = snapshotNumber;
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([
            RevaApi.PATH_VALUATIONS,
            this.id,
            RevaApi.PATH_VALUATION_SNAPSHOTS,
            String(this.snapshotNumber),
        ]);
    }
}
